import { notification } from 'antd';

export default function ShowErrorNotification(message?: string) {
    notification["error"]({
        message: "Une erreur est survenue",
        description: message
    });
}